"use strict";
(function () {
  if (!customElements.get("sticky-atc-bar")) {
    class StickyAtcBar extends HTMLElement {
      constructor() {
        super();
        this.setStickyBarHeight.bind(this);
        this.parent = this.closest(".sticky-atc-bar");
        this.select = this.querySelector(".atc-product-form .select__select");
        this.formBtn = this.querySelector(".button-add-card");
      }

      connectedCallback() {
        this.onVariantChange();
        this.attachResizeHandler();
        this.setStickyBarHeight();
        this.initializeButtonState();
      }

      disconnectedCallback() {
        this.cleanup();
      }

      onVariantChange = () => {
        if (!this.select) return;
        this.select.addEventListener("change", (e) => {
          this.updateMasterId(e);

          const hiddenIdInput = this.querySelector(
            '.atc-product-form input[type="hidden"][name="id"]'
          );
          if (hiddenIdInput) hiddenIdInput.value = e.target.value;

          const option =
            e.target.selectedOptions && e.target.selectedOptions[0];
          if (option) {
            const mediaUrl = option.getAttribute("data-media");
            const img = this.querySelector(".atc-product-media img");
            if (mediaUrl && img) {
              img.src = mediaUrl;
              img.srcset = mediaUrl;
            }
          }

          this.updateButtonFromVariantData(e.target.value);

          this.renderProductInfo();
        });
      };

      updateMasterId(e) {
        this.currentVariant = e.target.value;
      }

      renderProductInfo() {
        const requestedVariantId = this.currentVariant;
        fetch(`${this.dataset.url}?variant=${requestedVariantId}`)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(
              responseText,
              "text/html"
            );

            const addButtonUpdated =
              html.querySelector(".main-product .product-form__submit") ||
              html.querySelector(".product-section .product-form__submit") ||
              html.querySelector(".product-form__submit");

            if (addButtonUpdated) {
              const isDisabled = addButtonUpdated.hasAttribute("disabled");
              const buttonText = isDisabled
                ? window.variantStrings.soldOut
                : window.variantStrings.addToCart;
              this.toggleAddButton(isDisabled, buttonText);
            }

            const priceContainer =
              html.querySelector(".main-product .price__container") ||
              html.querySelector('[id^="price-"] .price__container') ||
              html.querySelector(".price__container");
            if (priceContainer) {
              this.updatePrice(priceContainer);
            } else {
              const option = this.select?.selectedOptions?.[0];
              const priceText = option?.getAttribute("data-price");
              if (priceText) {
                const regular = this.querySelector(
                  ".price .price-item--regular"
                );
                if (regular) regular.innerHTML = priceText;
              }
            }
            this.updatePrice(priceContainer);
          })
          .catch((error) => {
            console.error("Error:", error);
          });
      }

      toggleAddButton(disable = true, text, modifyClass = true) {
        const addButton = this.formBtn;
        if (!addButton) return;

        const addButtonText = addButton.querySelector("span");

        if (disable) {
          addButton.setAttribute("disabled", "disabled");
          if (text && addButtonText) {
            addButtonText.textContent = text;
          }
        } else {
          addButton.removeAttribute("disabled");
          if (addButtonText) {
            addButtonText.textContent = text || window.variantStrings.addToCart;
          }
        }

        if (!modifyClass) return;
      }

      updatePrice(newPrice) {
        if (!newPrice) return;

        const oldPrice = this.querySelector(".price__container");
        if (!oldPrice) return;

        const parent = oldPrice.parentNode;
        const cloned = newPrice.cloneNode(true);
        parent.replaceChild(cloned, oldPrice);
      }

      setStickyBarHeight() {
        let height = 0;
        if (this.parent) {
          height = this.parent.offsetHeight;
        }

        document.documentElement.style.setProperty(
          "--atc-bar-height",
          `${height}px`
        );
      }

      attachResizeHandler() {
        this.resizeObserver = new ResizeObserver(() =>
          this.setStickyBarHeight()
        );
        this.resizeObserver.observe(this);
        window.addEventListener("resize", () => {
          this.setStickyBarHeight.call(this);
        });
      }

      cleanup() {
        if (this.resizeObserver) {
          this.resizeObserver.disconnect();
        }
      }

      initializeButtonState() {
        if (this.select) {
          const currentVariantId = this.select.value;
          if (currentVariantId) {
            this.currentVariant = currentVariantId;
            this.renderProductInfo();
            this.updateButtonFromVariantData(currentVariantId);
          }
        }
      }

      updateButtonFromVariantData(variantId) {
        const variantDataScript = this.querySelector("[data-product-variants]");
        if (!variantDataScript) return;

        let variantData;
        try {
          variantData = JSON.parse(variantDataScript.textContent);
        } catch (e) {
          return;
        }

        const selectedVariant = variantData.find(
          (v) => v.id.toString() === variantId
        );
        if (!selectedVariant) return;

        const addButton = this.querySelector(".button-add-card");
        const addButtonText = addButton?.querySelector("span");

        if (addButton && addButtonText) {
          if (selectedVariant.available) {
            addButton.removeAttribute("disabled");
            addButtonText.textContent =
              window.variantStrings?.addToCart || "Add to cart";
          } else {
            addButton.setAttribute("disabled", "disabled");
            addButtonText.textContent =
              window.variantStrings?.soldOut || "Sold out";
          }
        }
      }
    }

    customElements.define("sticky-atc-bar", StickyAtcBar);

    function checkBarVisibility() {
      const stickyAtcBar = document.querySelector(".sticky-atc-bar");
      const productVisible = document.querySelector(
        ".product .product__info-wrapper"
      );
      document.addEventListener("scroll", (e) => {
        let productVisibleHeight = productVisible.offsetHeight / 2;
        let scrolled = document.scrollingElement.scrollTop;

        if (
          scrolled > productVisibleHeight &&
          !stickyAtcBar.classList.contains("js-hidden")
        ) {
          stickyAtcBar.classList.add("atc-visible");
        } else {
          stickyAtcBar.classList.remove("atc-visible");
        }
      });
    }

    document.addEventListener("DOMContentLoaded", checkBarVisibility);
    document.addEventListener("shopify:section:load", checkBarVisibility);

    function addStickySpace() {
      const stickyAtcBar = document.querySelector(".sticky-atc-bar");
      if (!stickyAtcBar) return;

      let totalBottomOffset = 15;
      if (stickyAtcBar.classList.contains("default") || window.innerWidth < 750) {
        totalBottomOffset = 0;
      }
      stickyAtcBar.style.bottom = `${totalBottomOffset}px`;
    }

    document.addEventListener("DOMContentLoaded", addStickySpace);
    document.addEventListener("shopify:section:load", addStickySpace);
    window.addEventListener("resize", addStickySpace);
    window.addEventListener("scroll", addStickySpace);
  }

  if (!customElements.get("sticky-atc-variants")) {
    class StickyAtcVariants extends HTMLElement {
      constructor() {
        super();
        this.handleSwatchClick = this.handleSwatchClick.bind(this);
        this.handleSwatchKeydown = this.handleSwatchKeydown.bind(this);
        this.addActiveState = this.addActiveState.bind(this);
        this.checkCurrentVariant = this.checkCurrentVariant.bind(this);
      }

      connectedCallback() {
        this.init();
      }

      disconnectedCallback() {
        this.cleanup();
      }

      init() {
        this.productCard = this.closest("sticky-atc-bar");
        if (!this.productCard) return;

        this.url = this.productCard.dataset.url || "";
        this.select = this.productCard.querySelector(".select__select");
        this.cardColorSwatches = [...this.querySelectorAll(".card-variant")];
        if (!this.cardColorSwatches.length || !this.select) return;

        this.currentId =
          this.select.value || this.cardColorSwatches[0]?.dataset.variantId;

        this.cardColorSwatches.forEach((swatch) => {
          swatch.addEventListener("click", this.handleSwatchClick);
          swatch.addEventListener("keydown", this.handleSwatchKeydown);
        });

        this.addActiveState();
      }

      handleSwatchClick(event) {
        event.preventDefault();
        event.stopPropagation();
        const swatch = event.currentTarget;
        this.updateActiveSwatch(swatch);
      }

      handleSwatchKeydown(event) {
        if (event.key === "Enter" || event.key === " ") {
          event.preventDefault();
          const swatch = event.currentTarget;
          this.updateActiveSwatch(swatch);
        }
      }

      updateActiveSwatch(swatch) {
        const { variantId } = swatch.dataset;
        if (!variantId || this.checkCurrentVariant(variantId)) return;

        const matchingOption = Array.from(this.select.options).find(
          (option) => option.value === variantId
        );

        if (matchingOption) {
          this.select.value = variantId;
          this.select.dispatchEvent(new Event("change", { bubbles: true }));

          if (
            this.productCard &&
            this.productCard.updateButtonFromVariantData
          ) {
            this.productCard.updateButtonFromVariantData(variantId);
          }

          if (this.productCard && this.productCard.renderProductInfo) {
            this.productCard.currentVariant = variantId;
            this.productCard.renderProductInfo();
          }
        }

        this.addActiveState();
      }

      addActiveState() {
        let foundActive = false;

        this.cardColorSwatches.forEach((swatch) => {
          const { variantId } = swatch.dataset;

          if (variantId === this.select.value && !foundActive) {
            swatch.classList.add("active");
            foundActive = true;
          } else {
            swatch.classList.remove("active");
          }
        });
      }

      checkCurrentVariant(id) {
        if (this.currentId === id) {
          return true;
        }
        this.currentId = id;
        return false;
      }

      cleanup() {
        this.cardColorSwatches.forEach((swatch) => {
          swatch.removeEventListener("click", this.handleSwatchClick);
          swatch.removeEventListener("keydown", this.handleSwatchKeydown);
        });
      }
    }

    customElements.define("sticky-atc-variants", StickyAtcVariants);
  }

  const stickyAtcBtn = document.querySelector(".sticky-atc-bar__close");

  if (stickyAtcBtn) {
    const addOnClickHandler = () => {
      const stickyAtcBar = document.querySelector(".sticky-atc-bar");
      if (!stickyAtcBar) return;

      stickyAtcBtn.addEventListener("click", () => {
        stickyAtcBar.classList.add("js-hidden");
        stickyAtcBar.classList.remove("atc-visible");
      });

      stickyAtcBtn.addEventListener("keydown", (e) => {
        if (e.key === "Enter" || e.key === " " || e.key === "Escape" || e.key === "Esc") {
          stickyAtcBar.classList.add("js-hidden");
          stickyAtcBar.classList.remove("atc-visible");
        }
      });
    };

    addOnClickHandler();
  }

  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape" || e.key === "Esc") {
      const stickyAtcBar = document.querySelector(".sticky-atc-bar");
      if (stickyAtcBar && !stickyAtcBar.classList.contains("js-hidden")) {
        stickyAtcBar.classList.add("js-hidden");
        stickyAtcBar.classList.remove("atc-visible");
      }
    }
  });
  window.addEventListener("variant:change", function (e) {
    const variant = e.detail.variant;
    if (!variant) return;
    const stickyBar = document.querySelector("sticky-atc-bar");
    if (!stickyBar) return;

    const img = stickyBar.querySelector(".atc-product-media img");
    if (img && variant.featured_image && variant.featured_image.src) {
      img.src = variant.featured_image.src;
      img.alt = variant.featured_image.alt || "";
    }

    const select = stickyBar.querySelector('select[name="id"]');
    if (select) {
      Array.from(select.options).forEach((opt) =>
        opt.removeAttribute("selected")
      );
      const option = select.querySelector(`option[value="${variant.id}"]`);
      if (option) option.setAttribute("selected", "selected");
      select.value = variant.id;
      select.dispatchEvent(new Event("change", { bubbles: true }));
    }

    const priceContainer = stickyBar.querySelector(".price__container");
    if (priceContainer && typeof window.renderPrice === "function") {
      window.renderPrice(priceContainer, variant);
    } else if (priceContainer && variant.price) {
      priceContainer.innerHTML = `${(variant.price / 100).toFixed(2)} ${
        window.cartStrings?.currency || ""
      }`;
    }

    const title = stickyBar.querySelector(".atc-product-title");
    if (title) {
      const productTitle = stickyBar.dataset.productTitle;
      title.textContent = productTitle || title.textContent;
    }

    const addButton = stickyBar.querySelector(".button-add-card");
    const addButtonText = addButton?.querySelector("span");
    if (addButton && addButtonText) {
      if (variant.available) {
        addButton.removeAttribute("disabled");
        addButtonText.textContent =
          window.variantStrings?.addToCart || "Add to cart";
      } else {
        addButton.setAttribute("disabled", "disabled");
        addButtonText.textContent =
          window.variantStrings?.soldOut || "Sold out";
      }
    }

    // Reset quantity to default value
    const quantityInput = stickyBar.querySelector(".quantity__input");
    if (quantityInput) {
      const minQuantity = quantityInput.getAttribute("data-min") || "1";
      quantityInput.value = minQuantity;

      // Also update value in quantity-input element if it exists
      const quantityInputElement = quantityInput.closest("quantity-input");
      if (quantityInputElement) {
        quantityInputElement.value = minQuantity;
      }
    }
  });

  if (
    typeof subscribe === "function" &&
    typeof PUB_SUB_EVENTS !== "undefined"
  ) {
    subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
      const variant = data.variant;
      if (!variant) return;
      const stickyBar = document.querySelector("sticky-atc-bar");
      if (!stickyBar) return;
      const img = stickyBar.querySelector(".atc-product-media img");
      if (img && variant.featured_image && variant.featured_image.src) {
        img.src = variant.featured_image.src;
        img.alt = variant.featured_image.alt || "";
      }
      const select = stickyBar.querySelector('select[name="id"]');
      if (select) {
        Array.from(select.options).forEach((opt) =>
          opt.removeAttribute("selected")
        );
        const option = select.querySelector(`option[value="${variant.id}"]`);
        if (option) option.setAttribute("selected", "selected");
        select.value = variant.id;
        select.dispatchEvent(new Event("change", { bubbles: true }));
      }
      const priceContainer = stickyBar.querySelector(".price__container");
      if (priceContainer && typeof window.renderPrice === "function") {
        window.renderPrice(priceContainer, variant);
      } else if (priceContainer && variant.price) {
        priceContainer.innerHTML = `${(variant.price / 100).toFixed(2)} ${
          window.cartStrings?.currency || ""
        }`;
      }
      const title = stickyBar.querySelector(".atc-product-title");
      if (title) {
        const productTitle = stickyBar.dataset.productTitle;
        title.textContent = productTitle || title.textContent;
      }
      const addButton = stickyBar.querySelector(".button-add-card");
      const addButtonText = addButton?.querySelector("span");
      if (addButton && addButtonText) {
        if (variant.available) {
          addButton.removeAttribute("disabled");
          addButtonText.textContent =
            window.variantStrings?.addToCart || "Add to cart";
        } else {
          addButton.setAttribute("disabled", "disabled");
          addButtonText.textContent =
            window.variantStrings?.soldOut || "Sold out";
        }
      }

      // Reset quantity to default value
      const quantityInput = stickyBar.querySelector(".quantity__input");
      if (quantityInput) {
        const minQuantity = quantityInput.getAttribute("data-min") || "1";
        quantityInput.value = minQuantity;

        // Also update value in quantity-input element if it exists
        const quantityInputElement = quantityInput.closest("quantity-input");
        if (quantityInputElement) {
          quantityInputElement.value = minQuantity;
        }
      }
    });
  }
})();
